import videojs from 'video.js';
import './Vimeo.js';

class Home {
  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;
    // this.debug = true;
    this.homeStoriesShortVideos = [];
    this.homeStoriesFullVideos = [];
    this.isfullscreen = false;
    this.autoplayCheck = null;
    this.mutedChecks = [];
  }

  init() {

    let _self = this;

    // this.noHomeStories = window.location.search.indexOf("no_home_stories=1") != -1 ? true : false;
    if(_self.debug) console.log('Home init', $(window), this.noHomeStories);
    
    // $(window).on('load', function(){

      let homeStories = $('#home-stories');
      _self.homeStoriesContainer = $('#home-stories-container');
      // if(this.noHomeStories === false && homeStories.length) {
      if(homeStories.length) {

        _self.homeStories_slides = homeStories.find('.swiper-slide');
        if(_self.homeStories_slides.length > 1) {


          //video short
          _self.videoShortOptions = {
            paused: true,
            autoplay: false,
            loop: false,
            controls: false,
            responsive: true,
            fluid: true,
            muted: true,
            aspectRatio: '375:666',
            vimeo: {
              pip: false,
              background: false,
              loop: false,
              maxheight: 1234
            }
          };
          _self.videoFullOptions = {
            paused: true,
            autoplay: false,
            loop: false,
            controls: false,
            responsive: true,
            fluid: true,
            muted: false,
            aspectRatio: '1:1',
            vimeo: {
              pip: false,
              loop: false,
              background: false,
              maxheight: 1234
            }
          };


          _self.homeStories_slides.each(function(i,slide){

            if(i == 0) {

              _self.loadShortVideo(i,slide);
              if($('html').hasClass('loading')) {
                if(_self.debug) console.log('Home homeStories LOAD event add loadFullVideo i', i);
                $(window).on('load', function(e){
                  if(_self.debug) console.log('Home homeStories LOAD event loadFullVideo i', i);
                  _self.loadFullVideo(i,slide);
                });
              } else {
                setTimeout(function(){
                  if(_self.debug) console.log('Home homeStories ALREADY loaded loadFullVideo i', i);
                  _self.loadFullVideo(i,slide);
                },400);
              }

            } else {
              
              if($('html').hasClass('loading')) {
                
                if(_self.debug) console.log('Home homeStories LOAD event loadShortVideo + loadFullVideo i', i);
                $(window).on('load', function(e){
                  _self.loadShortVideo(i,slide);
                  _self.loadFullVideo(i,slide);
                });

              } else {

                setTimeout(function(){
                  if(_self.debug) console.log('Home homeStories ALREADY loaded loadShortVideo i', i);
                  _self.loadShortVideo(i,slide);
                },400);

                setTimeout(function(){
                  if(_self.debug) console.log('Home homeStories ALREADY loaded loadFullVideo i', i);
                  _self.loadFullVideo(i,slide);
                },800);

              }

            }

          });


          if (_self.debug) console.log('homeStories homeStoriesShortVideos', _self.homeStoriesShortVideos);

          _self.homeStoriesSwiper = new Swiper(homeStories.get(0), {
            slidesPerView: 3,
            autoHeight: true,
            // slidesPerColumn: 2,
            spaceBetween: 20,
            // slidesPerGroup: 2,
            watchOverflow: false,
            normalizeSlideIndex: false,
            threshold: 30,
            // spaceBetween: -5,
            // loop: true,
            // loopFillGroupWithBlank: true,
            virtualTranslate: true,
            slideToClickedSlide: true,
            breakpoints: {
              768: {
                watchOverflow: true,
                virtualTranslate: false,
                slidesPerView: 1,
                normalizeSlideIndex: true,
                // spaceBetween: 24
              },
              // 1280: {
              //   spaceBetween: 30
              // },
            //   // 1024: {
            //   //   spaceBetween: -10,
            //   // },
            //   // 1280: {
            //   //   spaceBetween: -20,
            //   // },
            },
            navigation: {
              nextEl: homeStories.find('.swiper-button-next').get(0),
              prevEl: homeStories.find('.swiper-button-prev').get(0),
            },
            pagination: {
              el: '.swiper-pagination',
              // type: 'bullets',
              type: 'custom',
              clickable: true,
              renderCustom: function(swiper, current, total){

                
                let _self = this;
                
                if(_self.debug) console.log('homeStoriesSwiperPaginationRender swiper, current, total', swiper, current, total, 'this', this);
                
                let numberOfBullets = swiper.slides.length;
                let activeBullet = swiper.activeIndex;

                let paginationHTML = '';
                for (let i = 0; i < numberOfBullets; i += 1) {
                  if(i == activeBullet) paginationHTML += `<${this.bulletElement} class="${this.bulletClass} ${this.bulletActiveClass}"></${this.bulletElement}>`;
                  else paginationHTML += `<${this.bulletElement} class="${this.bulletClass}"></${this.bulletElement}>`;

                  // <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                  //   <span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1" aria-current="true"></span>
                  //   <span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 2"></span>
                  //   <span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 3"></span>
                  // </div>

                }
                swiper.pagination.$el.html(paginationHTML);
                // swiper.pagination.update();
              }
            },
            on: {
              // 'resize': function () {
              //   this.changeDirection(_self.getDirection());
              // },
              'lock': function(){
                if(_self.debug) console.log('lock event', this.el);
                $(this.el).addClass('swiper-pagination-locked');
              },
              'unlock': function(){
                if(_self.debug) console.log('unlock event', this.el);
                $(this.el).removeClass('swiper-pagination-locked');
              },
              'slideChangeTransitionEnd': function(){
                if(_self.debug) console.log('slideChangeTransitionEnd event', this.el);
                if(_self.isFullscreen) {
                  $.each(_self.homeStoriesFullVideos, function(i,fullVideo){
                    if(i == _self.homeStoriesSwiper.activeIndex) {
                      if(typeof fullVideo.tech_ != 'undefined' && typeof fullVideo.tech_.vimeoPlayer != 'undefined') {
                        fullVideo.tech_.vimeoPlayer.setLoop(false).then(function(){
                          fullVideo.play();
                        });
                      }
                    } else {
                      if(typeof fullVideo.tech_ != 'undefined' && typeof fullVideo.tech_.vimeoPlayer != 'undefined') {
                        fullVideo.pause();
                      }
                    }
                  });
                } else {
                  $.each(_self.homeStoriesShortVideos, function(i,shortVideo){
                    if(i == _self.homeStoriesSwiper.activeIndex) {
                      // shortVideo.play();
                      _self.homeStoriesShortVideos[_self.homeStoriesSwiper.activeIndex].tech_.vimeoPlayer.getMuted().then(function(isMuted){
                        if(_self.debug) console.log('play short video '+i+' after slide transition getMuted isMuted', isMuted);
                        _self.homeStoriesShortVideos[_self.homeStoriesSwiper.activeIndex].tech_.vimeoPlayer.getPaused().then(function(paused){
                          if(_self.debug) console.log('play short video '+i+' after slide transition getPaused paused', paused);
                          _self.homeStoriesShortVideos[_self.homeStoriesSwiper.activeIndex].play();
                        });
                      });
                    }
                    else {
                      _self.homeStoriesShortVideos[_self.homeStoriesSwiper.activeIndex].pause();
                    }
                  });
                }
              }
            },

          });

        }
      }

    // });

    let homeTitleWords = $('.o-landing--home__title-words');
    if(homeTitleWords.length) {
      let homeTitleWords_slides = homeTitleWords.find('.swiper-slide');
      if(homeTitleWords_slides.length > 1) {
        _self.homeTitleWordsSwiper = new Swiper(homeTitleWords.get(0), {
          slidesPerView: 1,
          loop: true,
          autoplay: true,
          autoHeight: false,
          direction: 'vertical',
          spaceBetween: 20,
          allowTouchMove: false
        });
      }
    }
    

    let homeJobsLatestImages = $('.o-jobs-latest__thumbs-slider');
    let homeJobsLatest = $('.o-jobs-latest__slider');
    if(homeJobsLatest.length && homeJobsLatestImages.length) {
      _self.homeJobsLatestSwiper = new Swiper(homeJobsLatest.get(0), {
        slidesPerView: 3,
        autoHeight: false,
        direction: 'vertical',
        touchReleaseOnEdges: true,
      });
      _self.homeJobsLatestImagesSwiper = new Swiper(homeJobsLatestImages.get(0), {
        slidesPerView: 1,
        autoplay: true,
        autoHeight: true,
        effect: 'fade',
        touchReleaseOnEdges: true,
        thumbs: {
          swiper: _self.homeJobsLatestSwiper,
        }
      });
    }

    _self.homeScrollTrigger = ScrollTrigger.create({
      id: 'homeScrollTrigger',
      trigger: $('.o-landing--home').get(0),
      start: "top bottom",
      end: "bottom top",
      onToggle: self => {
        //is it in view ?
        if (self.isActive) { // yes

          // resume words autoplay if not running
          if('undefined' != typeof _self.homeTitleWordsSwiper && !_self.homeTitleWordsSwiper.autoplay.running) _self.homeTitleWordsSwiper.autoplay.start();

          // resume jobs autoplay if not running
          if('undefined' != typeof _self.homeJobsLatestImagesSwiper && !_self.homeJobsLatestImagesSwiper.autoplay.running) _self.homeJobsLatestImagesSwiper.autoplay.start();

          // resume stories short video of current slide
          $.each(_self.homeStoriesShortVideos, function(i,shortVideo){

            if(i == _self.homeStoriesSwiper.activeIndex) {
              if(typeof shortVideo.tech_ != 'undefined' && typeof shortVideo.tech_.vimeoPlayer != 'undefined') {
                       
                shortVideo.tech_.vimeoPlayer.getMuted().then(function(isMuted){
                  if(_self.debug) console.log('play short video '+i+' homeScrollTrigger is in view getMuted isMuted', isMuted);
                  shortVideo.tech_.vimeoPlayer.getPaused().then(function(paused){
                    if(_self.debug) console.log('play short video '+i+' homeScrollTrigger is in view getPaused paused', paused);
                    shortVideo.play();
                  });
                });

              }
              
            }

          });
          
        } else { // no
          
          // stop words autoplay
          if(_self.debug) console.log('homeScrollTrigger pause homeTitleWordsSwiper', _self.homeTitleWordsSwiper);
          if('undefined' != typeof _self.homeTitleWordsSwiper) {
            if(_self.debug) console.log('homeScrollTrigger pause homeTitleWordsSwiper', _self.homeTitleWordsSwiper);
            _self.homeTitleWordsSwiper.autoplay.stop();
          }
          
          // stop jobs autoplay
          if('undefined' != typeof _self.homeJobsLatestImagesSwiper) _self.homeJobsLatestImagesSwiper.autoplay.stop();
          
          // pause stories short videos
          $.each(_self.homeStoriesShortVideos, function(i,shortVideo){
            shortVideo.pause();
          });
          // TODO : completely hide videos to save resources ?
        }

      },
      markers: _self.debug,
    });

    // this.homeScrollTrigger.disable();

    window.Home = this;

  }

  loadShortVideo(i,videoContainer){

    let _self = this;

    let videoShortElement = $(videoContainer).find('video.o-stories__item-video-short').get(0);
    
    if(_self.debug) console.log('homeStories videoShortElement', videoShortElement);
    if(videoShortElement) {
      
      $(videoShortElement).attr('data-setup', $(videoShortElement).attr('data-setup-videojs'));
        
      //init videojs player for short video
      let videoShortPlayer = videojs(videoShortElement, _self.videoShortOptions, () => {
        if(_self.debug) videojs.log('player is ready', this);
        // onReady && onReady(player);

        setTimeout(function(){ 

          if(_self.debug) console.log('homeStories videoShortElement setTimeout videoShortPlayer?', videoShortPlayer);

          videoShortPlayer.on('ended', function(e){
            let slideIndex = $(videoShortPlayer.el_).closest('.swiper-slide').index();
            if(_self.debug) console.log('homeStories videoShortPlayer ended event slideIndex', e, slideIndex, _self.homeStoriesShortVideos[slideIndex]);
            //rewind current video
            _self.homeStoriesShortVideos[slideIndex]?.tech_?.setCurrentTime(0);
            // play next video / slide to next slide
            let nextVideoIndex = (slideIndex == _self.homeStories_slides.length-1) ? 0 : i+1;
            _self.homeStoriesSwiper.slideTo(nextVideoIndex);
          });

          videoShortPlayer.on('play', function(e){
            let slideIndex = $(videoShortPlayer.el_).closest('.swiper-slide').index();
            if(_self.debug) console.log('homeStories videoShortPlayer play event', e, slideIndex, _self.homeStoriesShortVideos[slideIndex]);
            if(slideIndex != 0) {
              clearInterval(_self.mutedChecks[slideIndex-1]);
            }
          });

          videoShortPlayer.on('error', function(err){
            if(_self.debug) console.log('error: ',err, videoShortPlayer?.tech_.errorName);
            if((videoShortPlayer?.tech_.errorName == 'PlayInterrupted' || videoShortPlayer?.tech_.errorName == 'AbortError') && videoShortPlayer?.tech_.errorMethod == 'play') {
              if(_self.debug) console.log('videoShortPlayer '+i+' '+videoShortPlayer?.tech_.errorName+' play', videoShortPlayer);
              
              videoShortPlayer?.tech_.vimeoPlayer.setMuted(true).then(function(){
                videoShortPlayer?.tech_.vimeoPlayer.getPaused().then(function(paused){
                  if(paused) {
                    videoShortPlayer.error(null);
                    if(_self.debug) console.log('videoShortPlayer '+videoShortPlayer?.tech_.errorName+' play new attempt', videoShortPlayer);
                    videoShortPlayer.play();
                  }
                });
              });
            }
          });
          // videoShortPlayer?.tech_.VimeoPlayer.on('ended', function(e){
          //   if(_self.debug) console.log('homeStories videoShortPlayer?.tech_.VimeoPlayer ended event', e);
          // });
          videoShortPlayer.on('stalled', function(e){
            if(_self.debug) console.log('homeStories videoShortPlayer stalled event', e);
          });
          // videoShortPlayer.on('any', function(e){
          //   if(_self.debug) console.log('homeStories videoShortPlayer any event', e);
          // });
          videoShortPlayer.on('timeupdate', function(e){
            // if(_self.debug) console.log('homeStories videoShortPlayer timeupdate event', e, videoShortPlayer?.tech_.vimeoInfo.buffered, $(_self.homeStoriesSwiper.pagination.$el).find('.swiper-pagination-bullet').eq(i));
            // $(_self.homeStoriesSwiper.pagination.$el).find('.swiper-pagination-bullet').eq(i).css('--video-progress', 'scaleX('+ videoShortPlayer?.tech_.vimeoInfo.buffered+')');
            $(_self.homeStoriesSwiper.pagination.$el).find('.swiper-pagination-bullet').eq(i).attr('style','--video-progress:'+ videoShortPlayer?.tech_.vimeoInfo.buffered);
            if(i == 0 && videoShortPlayer?.tech_.vimeoInfo.buffered > 0) clearInterval(_self.autoplayCheck);
          });
          if(i == 0) {
            _self.autoplayCheck = setInterval(function(){
              if(_self.debug) console.log('homeStories autoplayCheck vjs-waiting?', $(videoShortElement).hasClass('vjs-waiting'), videoShortPlayer?.tech_);
              if(_self.debug) console.log('homeStories autoplayCheck vjs-waiting?', $(videoShortElement).hasClass('vjs-waiting'), videoShortPlayer?.tech_);
              if($(videoShortPlayer.el_).hasClass('vjs-waiting') || $(videoShortPlayer.el_).hasClass('vjs-paused')) {
                if(typeof videoShortPlayer?.tech_ != 'undefined' && typeof videoShortPlayer?.tech_.vimeoPlayer != 'undefined') {
                  videoShortPlayer?.tech_.vimeoPlayer.setLoop(false).then(function(){
                    videoShortPlayer?.tech_.vimeoPlayer.setMuted(true).then(function(){
                      videoShortPlayer?.tech_.vimeoPlayer.getPaused().then(function(paused){
                        if(paused) {
                          if(_self.debug) console.log('homeStories autoplayCheck play', videoShortPlayer);
                          videoShortPlayer.play()
                          clearInterval(_self.autoplayCheck);
                        }
                      });
                    });
                  });
                }
              }
            },500);
          }

          if(i != 0) {
            videoShortPlayer.pause();
            let mutedCheck = setInterval(function(){
              if(_self.debug) console.log('homeStories mutedCheck vjs-waiting?', $(videoShortElement).hasClass('vjs-waiting'), videoShortPlayer?.tech_);
              if(typeof videoShortPlayer?.tech_ != 'undefined' && typeof videoShortPlayer?.tech_.vimeoPlayer != 'undefined') {
                videoShortPlayer?.tech_.vimeoPlayer.setMuted(true).then(function(wha){
                  if(_self.debug) console.log('homeStories mutedCheck videoShortPlayer muted apparently? clearing interval', wha, _self.mutedChecks[i], $(videoShortPlayer.el_).closest('.swiper-slide').index());
                  clearInterval(_self.mutedChecks[$(videoShortPlayer.el_).closest('.swiper-slide').index()-1]);
                });
                videoShortPlayer?.tech_.vimeoPlayer.setLoop(false).then(function(){   
                  videoShortPlayer?.tech_.vimeoPlayer.getMuted().then(function(isMuted){
                    //already started
                    if(_self.debug) console.log('homeStories mutedCheck videoShortPlayer isMuted', isMuted);
                    if(isMuted) clearInterval(_self.mutedChecks[$(videoShortPlayer.el_).closest('.swiper-slide').index()-1]);
                  });
                });

              }
            },500);
            _self.mutedChecks.push(mutedCheck);
          }

        });
      });

      _self.homeStoriesShortVideos[i] = videoShortPlayer;

    }
    
    $(videoContainer).find('.btn-main, .o-stories__item-link').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      _self.homeStoriesContainer.addClass('is-fullscreen');
      _self.isFullscreen = true;
      $('html').addClass('has-fullscreen-video');
      let slideIndex = $(videoContainer).index();
      $(_self.homeStoriesSwiper.pagination.$el).find('.swiper-pagination-bullet').attr('style','--video-progress:0');
      _self.homeStoriesShortVideos[slideIndex]?.pause();
      _self.homeStoriesFullVideos[slideIndex]?.tech_.vimeoPlayer.setLoop(false).then(function(){ 
        _self.homeStoriesFullVideos[slideIndex].play();
      });
      if(window.innerWidth < 768) {
        _self.homeStoriesSwiper.params.slidesPerView = 1;
        _self.homeStoriesSwiper.params.virtualTranslate = false;
        _self.homeStoriesSwiper.params.watchOverflow = true;
        _self.homeStoriesSwiper.params.normalizeSlideIndex = true;
        _self.homeStoriesSwiper.update();
      }
    });

    $(videoContainer).find('.btn-close').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      _self.homeStoriesContainer.removeClass('is-fullscreen');
      $('html').removeClass('has-fullscreen-video');
      let slideIndex = $(videoContainer).index();
      _self.isFullscreen = false;
      $(_self.homeStoriesSwiper.pagination.$el).find('.swiper-pagination-bullet').attr('style','--video-progress:0');
      _self.homeStoriesShortVideos[slideIndex]?.tech_?.vimeoPlayer.getMuted().then(function(isMuted){
        if(_self.debug) console.log('play short video '+slideIndex+' after return from fullscreen', this, 'isMuted', isMuted);
        _self.homeStoriesShortVideos[slideIndex]?.play();
      });
      _self.homeStoriesFullVideos[slideIndex].pause();
      if(window.innerWidth < 768) {
        _self.homeStoriesSwiper.params.slidesPerView = 3;
        $(_self.homeStoriesSwiper.wrapperEl).css('transform', 'translate3d(0px, 0px, 0px)');
        _self.homeStoriesSwiper.params.virtualTranslate = true;
        _self.homeStoriesSwiper.params.watchOverflow = false;
        _self.homeStoriesSwiper.params.normalizeSlideIndex = false;
        _self.homeStoriesSwiper.update();
      }
    });

    $(videoContainer).find('.btn-circle').on('click', function(e){
      // e.preventDefault();
      // e.stopPropagation();
      _self.homeStoriesContainer.removeClass('is-fullscreen');
      $('html').removeClass('has-fullscreen-video');
      _self.isFullscreen = false;

    });

  }

  loadFullVideo(i,videoContainer){

    let _self = this;
    if(_self.debug) console.log('homeStories loadFullVideo i', i, 'videoContainer', videoContainer);

    let videoFullElement = $(videoContainer).find('video.o-stories__item-video-full').get(0);

    if(_self.debug) console.log('homeStories videoFullElement', videoFullElement);
    if(videoFullElement) {

      $(videoFullElement).attr('data-setup', $(videoFullElement).attr('data-setup-videojs'));

      //init videojs player for full video
      let videoFullPlayer = videojs(videoFullElement, _self.videoFullOptions, () => {
        if(_self.debug) videojs.log('videoFullPlayer player is ready', this);
        // onReady && onReady(player);
        setTimeout(function(){

          videoFullPlayer.on('ended', function(e){
            if(_self.debug) console.log('homeStories videoFullPlayer ended event i', e, i, _self.homeStoriesFullVideos[i]);
            //rewind current video
            _self.homeStoriesFullVideos[i].tech_.setCurrentTime(0);
            // play next video / slide to next slide
            let nextVideoIndex = (i == _self.homeStories_slides.length-1) ? 0 : i+1;
            _self.homeStoriesSwiper.slideTo(nextVideoIndex);
          });
          videoFullPlayer.on('timeupdate', function(e){
            // if(_self.debug) console.log('homeStories videoShortPlayer timeupdate event', e, videoShortPlayer?.tech_.vimeoInfo.buffered, $(_self.homeStoriesSwiper.pagination.$el).find('.swiper-pagination-bullet').eq(i));
            $(_self.homeStoriesSwiper.pagination.$el).find('.swiper-pagination-bullet').eq(i).attr('style','--video-progress:'+ videoFullPlayer?.tech_.vimeoInfo.buffered);
          });

          videoFullPlayer.pause();


          videoFullPlayer.on('error', function(err){
            if(_self.debug) console.log('error: ',err, videoFullPlayer?.tech_.errorName);
            if((videoFullPlayer?.tech_.errorName == 'PlayInterrupted' || videoFullPlayer?.tech_.errorName == 'AbortError') && videoFullPlayer?.tech_.errorMethod == 'play') {
              if(_self.debug) console.log('videoFullPlayer '+videoFullPlayer?.tech_.errorName+' play', videoFullPlayer);
              
              videoFullPlayer?.tech_.vimeoPlayer.getPaused().then(function(paused){
                if(paused) {
                  videoFullPlayer.error(null);
                  if(_self.debug) console.log('videoFullPlayer '+i+' '+videoFullPlayer?.tech_.errorName+' play new attempt', videoFullPlayer);
                  videoFullPlayer.play();
                }
              });
              
            }
          });

        });

      });

      _self.homeStoriesFullVideos[i] = videoFullPlayer;

    }

  }

  clearIntervalMuted() {

    let _self = this;

    $.each(_self.mutedChecks, function(i,mutedCheck){
      clearInterval(mutedCheck);
    });

  }

}

export { Home };
